import { useTheme } from '@mui/material';

import { LoadingSpinner } from '@modules/_shared/components/LoadingSpinner';
import { TopbarTitle } from '@modules/_shared/components/topbar/Topbar';

export const SuspenseFallback = ({
  topBarTitle,
  fullPage = false,
}: {
  topBarTitle?: string;
  fullPage?: boolean;
}) => {
  const theme = useTheme();
  const palette = (theme.vars ?? theme).palette;

  return (
    <>
      {topBarTitle != null && <TopbarTitle>{topBarTitle}</TopbarTitle>}
      <LoadingSpinner
        sx={{
          color: palette.grey[700],
          minHeight: fullPage ? '100vh' : undefined,
          p: 0,
        }}
      />
    </>
  );
};
